(() => {
  const { useState, useMemo, useEffect, useRef } = React;
  const LEAD_ENDPOINT = "https://wud.app.n8n.cloud/webhook/8a8a4265-f388-4ea8-af8f-c2d320c1d95e";
  function getCookie(name) {
    try {
      const match = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)")
      );
      return match ? decodeURIComponent(match[1]) : "";
    } catch (e) {
      return "";
    }
  }
  const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_id", "gclid", "fbclid"];
  function captureUTM() {
    try {
      const params = new URLSearchParams(window.location.search);
      const fromUrl = {};
      UTM_KEYS.forEach((k) => {
        if (params.has(k)) fromUrl[k] = params.get(k);
      });
      if (Object.keys(fromUrl).length > 0) {
        sessionStorage.setItem("mtv_utm", JSON.stringify(fromUrl));
      }
    } catch (e) {
    }
  }
  function getUTM() {
    try {
      const stored = sessionStorage.getItem("mtv_utm");
      if (stored) return JSON.parse(stored);
    } catch (e) {
    }
    try {
      const params = new URLSearchParams(window.location.search);
      const out = {};
      UTM_KEYS.forEach((k) => {
        if (params.has(k)) out[k] = params.get(k);
      });
      return out;
    } catch (e) {
      return {};
    }
  }
  function newEventId() {
    try {
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
      }
    } catch (e) {
    }
    return "mtv-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }
  function fireGenerateLead(eventId, monthValue) {
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "generate_lead", {
          method: "moteromsvelger",
          currency: "NOK",
          value: monthValue,
          event_id: eventId
        });
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: "generate_lead",
          method: "moteromsvelger",
          currency: "NOK",
          value: monthValue,
          event_id: eventId
        });
      }
    } catch (e) {
    }
    try {
      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead", {
          content_name: "moteromsvelger",
          currency: "NOK",
          value: monthValue
        }, { eventID: eventId });
      }
    } catch (e) {
    }
  }
  const CFG = (() => {
    try {
      const el = document.getElementById("mtv-config-data");
      if (el) return JSON.parse(el.textContent);
    } catch (e) {
      console.warn("[mtv] config parse failed", e);
    }
    return {};
  })();
  const cfgGet = (path, fallback) => {
    const parts = path.split(".");
    let cur = CFG;
    for (const p of parts) {
      if (cur == null) return fallback;
      cur = cur[p];
    }
    return cur == null || cur === "" ? fallback : cur;
  };
  const ROOM_SIZES_DEFAULT = [
    { id: "medium", label: "Medium", people: "6–10 personer", desc: "Perfekt for de fleste møterom – hverdagsarbeidshesten.", sqm: "", basePriceMonth: 1715, basePriceBuy: 84090, defaultScreen: 65, popular: true },
    { id: "large", label: "Stort", people: "10–16 personer", desc: "For større møterom og styrerom – mer rekkevidde og lyd.", sqm: "", basePriceMonth: 2278, basePriceBuy: 111670, defaultScreen: 75 }
  ];
  const PLATFORMS_DEFAULT = [
    { id: "teams", label: "Microsoft Teams", desc: "MTR-sertifisert" },
    { id: "meet", label: "Google Meet", desc: "Google Meet-sertifisert" },
    { id: "zoom", label: "Zoom", desc: "Zoom Rooms-sertifisert" }
  ];
  const SCREEN_SIZES_DEFAULT = [
    { size: 65, label: '65"', delta: -8890, deltaMonth: -181, extraMonth3yr: 490, extraMonth5yr: 320 },
    { size: 75, label: '75"', delta: 0, deltaMonth: 0, extraMonth3yr: 740, extraMonth5yr: 470 },
    { size: 85, label: '85"', delta: 10900, deltaMonth: 222, extraMonth3yr: 1080, extraMonth5yr: 690 }
  ];
  const ADDONS_DEFAULT = [
    { id: "ceiling-mic", title: "Takmikrofon", desc: "Sennheiser TeamConnect – diskret takmontert mic-rekke. Anbefales for større rom.", priceBuy: 18900, priceMonth3yr: 480, priceMonth5yr: 320 },
    { id: "control", title: 'Neat Pad 8"', desc: "Touchpanel for romreservering og rask møtestart.", priceBuy: 6500, priceMonth3yr: 400, priceMonth5yr: 270 },
    { id: "neat-center", title: "Neat Center", desc: "Bordsentrert mic-puck – anbefales for store rom og styrerom.", priceBuy: 0, priceMonth3yr: 990, priceMonth5yr: 690 },
    { id: "second-screen", title: "Ekstra skjerm", desc: "Sony BZ40L i samme størrelse som hovedskjermen. For delt innhold + deltakere parallelt.", priceBuy: 0, priceMonth3yr: 0, priceMonth5yr: 0, mirrorScreen: true },
    { id: "install", title: "Installasjon og opplæring", desc: "Komplett montasje av AV-tekniker + 1 times opplæring av brukerne på stedet.", priceBuy: 0, priceMonth3yr: 0, priceMonth5yr: 0, alwaysIncluded: true }
  ];
  const ROOM_SIZES = Array.isArray(CFG.rooms) && CFG.rooms.length ? CFG.rooms : ROOM_SIZES_DEFAULT;
  const PLATFORMS = Array.isArray(CFG.platforms) && CFG.platforms.length ? CFG.platforms : PLATFORMS_DEFAULT;
  const SCREEN_SIZES = Array.isArray(CFG.screens) && CFG.screens.length ? CFG.screens : SCREEN_SIZES_DEFAULT;
  const ADDONS = Array.isArray(CFG.addons) && CFG.addons.length ? CFG.addons : ADDONS_DEFAULT;
  const SHOW_BUY = CFG.show_buy_option === true;
  const STANDARD_TIER = {
    label: "Standard",
    platform: "teams",
    rooms: {
      medium: { defaultScreen: 65, screens: [65, 75] },
      large: { defaultScreen: 75, screens: [75, 85] }
    },
    price: {
      medium: { 65: { buy: 53970, month3: 1716, month5: 1101 }, 75: { buy: 57750, month3: 1836, month5: 1178 } },
      large: { 75: { buy: 67630, month3: 2151, month5: 1380 }, 85: { buy: 81320, month3: 2586, month5: 1659 } }
    },
    video: {
      medium: "Yealink A40 Collaboration Bar med CTP25",
      large: "Yealink A50 Collaboration Bar med CTP25"
    }
  };
  const standardScreensFor = (size) => {
    const r = STANDARD_TIER.rooms[size];
    return r ? r.screens : [65, 75];
  };
  const standardPriceFor = (size, screen, termYears) => {
    const byRoom = STANDARD_TIER.price[size];
    if (!byRoom) return { month: 0, buy: 0 };
    const room = STANDARD_TIER.rooms[size] || {};
    const p = byRoom[screen] || byRoom[room.defaultScreen];
    if (!p) return { month: 0, buy: 0 };
    return { month: termYears === 3 ? p.month3 : p.month5, buy: p.buy };
  };
  const standardFromMonth = (size) => {
    const byRoom = STANDARD_TIER.price[size];
    if (!byRoom) return null;
    let min = Infinity;
    Object.keys(byRoom).forEach((k) => { if (byRoom[k].month5 < min) min = byRoom[k].month5; });
    return min === Infinity ? null : min;
  };
  const TERM_LENGTHS = [
    { years: 3, label: "3 år", factor: 1.56 },
    { years: 5, label: "5 år", factor: 1 }
  ];
  const fmt = (n) => new Intl.NumberFormat("nb-NO").format(Math.round(n));
  const fmtKr = (n) => `${fmt(n)} kr`;
  function addonMonthlyPrice(a, scr, termYears) {
    if (a.mirrorScreen && scr) {
      return termYears === 3 ? scr.extraMonth3yr || 0 : scr.extraMonth5yr || 0;
    }
    return termYears === 3 ? a.priceMonth3yr || 0 : a.priceMonth5yr || 0;
  }
  function calcPrice({ tier, size, screen, addons, term, termYears }) {
    if (tier === "standard") {
      return standardPriceFor(size, screen, termYears);
    }
    const room = ROOM_SIZES.find((r) => r.id === size);
    const scr = SCREEN_SIZES.find((s) => s.size === screen);
    if (!room || !scr) return { month: 0, buy: 0 };
    let buy = room.basePriceBuy + scr.delta;
    let baseMonth = room.basePriceMonth + scr.deltaMonth;
    const termObj = TERM_LENGTHS.find((t) => t.years === termYears) || TERM_LENGTHS[1];
    let month = baseMonth * termObj.factor;
    ADDONS.forEach((a) => {
      if (a.alwaysIncluded || addons.includes(a.id)) {
        buy += a.priceBuy || 0;
        month += addonMonthlyPrice(a, scr, termYears);
      }
    });
    return { month, buy };
  }
  function suggestedPackage({ tier, size, platform, screen, addons }) {
    var _a;
    const room = ROOM_SIZES.find((r) => r.id === size);
    if (tier === "standard") {
      const lbl = (room == null ? void 0 : room.label) || "";
      return {
        name: `ABC ${lbl} Standard – Microsoft`,
        tierLabel: "Standard",
        items: [
          { name: `Sony ${screen}" BRAVIA BZ30L (440 nit) med veggfeste`, desc: "4K profesjonell skjerm. Veggfeste inkludert." },
          { name: STANDARD_TIER.video[size] || "Yealink Collaboration Bar med CTP25", desc: "Kamera, mikrofon og høyttaler med CTP25 touch-panel. Sertifisert for Microsoft Teams Rooms." },
          { name: "Installasjon og opplæring", desc: "Komplett montasje av sertifisert AV-tekniker + brukeropplæring." }
        ]
      };
    }
    const platformLabel = ((_a = PLATFORMS.find((p) => p.id === platform)) == null ? void 0 : _a.label) || "Plattform";
    const items = [];
    items.push({
      name: `Sony BZ40L ${screen}" skjerm med veggfeste`,
      desc: "4K UHD profesjonell BRAVIA-skjerm. Veggfeste inkludert."
    });
    if (size === "medium") {
      items.push({
        name: "NEATBAR 2 med Pad",
        desc: `Komplett kamera, mikrofon og høyttaler. Sertifisert for ${platformLabel}.`
      });
    } else {
      items.push({
        name: "NEATBAR Pro med Pad",
        desc: `Wide-angle kamera + 8-element mic-array for større rom. Sertifisert for ${platformLabel}.`
      });
    }
    if (addons.includes("ceiling-mic")) items.push({ name: "Sennheiser TeamConnect TCC2", desc: "Takmikrofon med beam-forming." });
    if (addons.includes("wireless")) items.push({ name: "Ochno trådløs deling", desc: "Klikk-og-del for opptil 3 samtidige presentere." });
    if (addons.includes("control")) items.push({ name: "Logitech Tap touchpanel", desc: '10" kontroll ved døren – romreservering + møtestart.' });
    if (addons.includes("second-screen")) items.push({ name: "Ekstra Sony BZ40L-skjerm", desc: "For delt innhold og deltakere parallelt." });
    items.push({ name: "Installasjon og opplæring", desc: "Komplett montasje av sertifisert AV-tekniker + 1 times brukeropplæring." });
    const sizeLabel = (room == null ? void 0 : room.label) || "";
    const platformShort = platformLabel.split(" ")[0];
    return {
      name: `ABC ${sizeLabel} Premium – ${platformShort}`,
      tierLabel: "Premium",
      items
    };
  }
  function Icon({ name, size = 20 }) {
    const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };
    const paths = {
      users: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }), /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "7", r: "4" }), /* @__PURE__ */ React.createElement("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }), /* @__PURE__ */ React.createElement("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })),
      teams: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "6", width: "13", height: "12", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "m16 10 5-3v10l-5-3" })),
      meet: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "6", width: "13", height: "12", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "m16 12 5-3v6l-5-3" })),
      zoom: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "2", y: "7", width: "14", height: "10", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "m22 9-6 3 6 3z" })),
      byod: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "4", width: "18", height: "12", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "M2 20h20M9 16v4M15 16v4" })),
      monitor: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "M8 21h8M12 17v4" })),
      mic: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "9", y: "2", width: "6", height: "11", rx: "3" }), /* @__PURE__ */ React.createElement("path", { d: "M5 10v2a7 7 0 0 0 14 0v-2M12 19v3" })),
      cast: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M2 16a6 6 0 0 1 6 6" }), /* @__PURE__ */ React.createElement("path", { d: "M2 12a10 10 0 0 1 10 10" }), /* @__PURE__ */ React.createElement("path", { d: "M2 8V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3" })),
      panel: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "M9 9h6v6H9z" })),
      layers: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "m12 2 9 5-9 5-9-5z" }), /* @__PURE__ */ React.createElement("path", { d: "m3 12 9 5 9-5" }), /* @__PURE__ */ React.createElement("path", { d: "m3 17 9 5 9-5" })),
      wrench: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M14.7 6.3a4 4 0 0 0-5.4 5.4l-7 7 2 2 7-7a4 4 0 0 0 5.4-5.4l-2.4 2.4-2-2z" })),
      check: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("polyline", { points: "20 6 9 17 4 12" })),
      arrow: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M5 12h14M13 5l7 7-7 7" })),
      shield: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" })),
      phone: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" })),
      mail: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }), /* @__PURE__ */ React.createElement("path", { d: "m22 6-10 7L2 6" })),
      pin: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 1 1 16 0z" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "10", r: "3" })),
      search: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("circle", { cx: "11", cy: "11", r: "8" }), /* @__PURE__ */ React.createElement("path", { d: "m21 21-4.35-4.35" })),
      cart: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("circle", { cx: "9", cy: "21", r: "1" }), /* @__PURE__ */ React.createElement("circle", { cx: "20", cy: "21", r: "1" }), /* @__PURE__ */ React.createElement("path", { d: "M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6" })),
      user: /* @__PURE__ */ React.createElement("g", { ...stroke }, /* @__PURE__ */ React.createElement("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }), /* @__PURE__ */ React.createElement("circle", { cx: "12", cy: "7", r: "4" }))
    };
    return /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": "true" }, paths[name]);
  }
  function PlatformIcon({ id }) {
    if (id === "teams") return /* @__PURE__ */ React.createElement(Icon, { name: "teams" });
    if (id === "meet") return /* @__PURE__ */ React.createElement(Icon, { name: "meet" });
    if (id === "zoom") return /* @__PURE__ */ React.createElement(Icon, { name: "zoom" });
    return /* @__PURE__ */ React.createElement(Icon, { name: "byod" });
  }
  function Step({ num, title, desc, active, done, children }) {
    return /* @__PURE__ */ React.createElement("div", { className: `step ${active ? "active" : ""} ${done ? "done" : ""}` }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "step-num" }, done ? /* @__PURE__ */ React.createElement(Icon, { name: "check", size: 16 }) : num)), /* @__PURE__ */ React.createElement("div", { className: "step-body" }, /* @__PURE__ */ React.createElement("div", { className: "step-head" }, /* @__PURE__ */ React.createElement("h2", null, title), desc && /* @__PURE__ */ React.createElement("p", null, desc)), children));
  }
  function TierStep({ value, onChange }) {
    const premFrom = (() => {
      const m = ROOM_SIZES.find((r) => r.id === "medium") || ROOM_SIZES[0];
      if (!m) return null;
      let minDelta = 0;
      SCREEN_SIZES.forEach((s) => { const d = s.deltaMonth || 0; if (d < minDelta) minDelta = d; });
      const f = (TERM_LENGTHS.find((t) => t.years === 5) || { factor: 1 }).factor;
      return Math.round((m.basePriceMonth + minDelta) * f);
    })();
    const tiers = [
      { id: "standard", eyebrow: "Yealink · Microsoft Teams", title: "Standard", desc: "Rimeligere komplett pakke. Teams-sertifisert, Sony BRAVIA 440 nit.", from: standardFromMonth("medium") },
      { id: "premium", eyebrow: "Neat · Teams, Meet eller Zoom", title: "Premium", desc: "Flaggskip. Lysere skjerm, flere plattformer, tillegg og kontrollpanel.", from: premFrom }
    ];
    return /* @__PURE__ */ React.createElement("div", { className: "choices cols-3" }, tiers.map((t) => /* @__PURE__ */ React.createElement("button", { key: t.id, className: `choice ${value === t.id ? "selected" : ""}`, onClick: () => onChange(t.id) }, /* @__PURE__ */ React.createElement("div", { className: "choice-eyebrow" }, t.eyebrow), /* @__PURE__ */ React.createElement("div", { className: "choice-title" }, t.title), /* @__PURE__ */ React.createElement("div", { className: "choice-desc" }, t.desc), t.from ? /* @__PURE__ */ React.createElement("div", { className: "choice-price" }, "fra ", /* @__PURE__ */ React.createElement("strong", null, fmtKr(t.from), "/mnd")) : null)));
  }
  function RoomSizeStep({ value, onChange, tier }) {
    return /* @__PURE__ */ React.createElement("div", { className: "choices cols-3" }, ROOM_SIZES.map((r) => {
      let fromMonth = r.basePriceMonth;
      if (tier === "standard") {
        const sf = standardFromMonth(r.id);
        if (sf != null) fromMonth = sf;
      }
      return /* @__PURE__ */ React.createElement("button", { key: r.id, className: `choice ${value === r.id ? "selected" : ""}`, onClick: () => onChange(r.id) }, /* @__PURE__ */ React.createElement("div", { className: "choice-eyebrow" }, /* @__PURE__ */ React.createElement(Icon, { name: "users", size: 14 }), " ", r.people), /* @__PURE__ */ React.createElement("div", { className: "choice-title" }, r.label), /* @__PURE__ */ React.createElement("div", { className: "choice-desc" }, r.desc), /* @__PURE__ */ React.createElement("div", { className: "choice-price" }, r.sqm ? `${r.sqm} · ` : "", "fra ", /* @__PURE__ */ React.createElement("strong", null, fmtKr(fromMonth), "/mnd")));
    }));
  }
  function PlatformStep({ value, onChange }) {
    return /* @__PURE__ */ React.createElement("div", { className: "choices cols-4" }, PLATFORMS.map((p) => /* @__PURE__ */ React.createElement("button", { key: p.id, className: `choice compact ${value === p.id ? "selected" : ""}`, onClick: () => onChange(p.id) }, /* @__PURE__ */ React.createElement("div", { className: "choice-icon" }, /* @__PURE__ */ React.createElement(PlatformIcon, { id: p.id })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "choice-title" }, p.label), /* @__PURE__ */ React.createElement("div", { className: "choice-desc", style: { fontSize: 12 } }, p.desc)))));
  }
  function ScreenStep({ value, onChange, roomSize, tier }) {
    if (tier === "standard") {
      const allowed = standardScreensFor(roomSize);
      const screens = SCREEN_SIZES.filter((s) => allowed.indexOf(s.size) !== -1);
      const def = (STANDARD_TIER.rooms[roomSize] || {}).defaultScreen;
      const labelFor = (s) => {
        if (s.size === def) return "Standard";
        const base = standardPriceFor(roomSize, def, 5).month;
        const here = standardPriceFor(roomSize, s.size, 5).month;
        const d = here - base;
        if (d === 0) return "Standard";
        return d > 0 ? `+${fmt(d)} kr/mnd` : `${fmt(d)} kr/mnd`;
      };
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "screen-picker" }, screens.map((s) => /* @__PURE__ */ React.createElement("button", { key: s.size, className: `screen-pill ${value === s.size ? "selected" : ""}`, onClick: () => onChange(s.size) }, /* @__PURE__ */ React.createElement("span", { className: "size" }, s.label), /* @__PURE__ */ React.createElement("span", { className: "label" }, labelFor(s))))));
    }
    const room = ROOM_SIZES.find((r) => r.id === roomSize);
    const standardSize = room == null ? void 0 : room.defaultScreen;
    const standardScreen = SCREEN_SIZES.find((s) => s.size === standardSize);
    const useMonthly = !SHOW_BUY;
    const formatDelta = (s) => {
      var _a, _b, _c, _d;
      if (s.size === standardSize) return "Standard";
      const sd = useMonthly ? (_a = s.deltaMonth) != null ? _a : 0 : (_b = s.delta) != null ? _b : 0;
      const rd = useMonthly ? (_c = standardScreen == null ? void 0 : standardScreen.deltaMonth) != null ? _c : 0 : (_d = standardScreen == null ? void 0 : standardScreen.delta) != null ? _d : 0;
      const d = sd - rd;
      if (d === 0) return "Standard";
      const suffix = useMonthly ? " kr/mnd" : " kr";
      return d > 0 ? `+${fmt(d)}${suffix}` : `${fmt(d)}${suffix}`;
    };
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "screen-picker" }, SCREEN_SIZES.map((s) => /* @__PURE__ */ React.createElement("button", { key: s.size, className: `screen-pill ${value === s.size ? "selected" : ""}`, onClick: () => onChange(s.size) }, /* @__PURE__ */ React.createElement("span", { className: "size" }, s.label), /* @__PURE__ */ React.createElement("span", { className: "label" }, formatDelta(s))))));
  }
  function AddonsStep({ value, onChange, screen, termYears }) {
    const scr = SCREEN_SIZES.find((s) => s.size === screen);
    const toggle = (id) => {
      if (value.includes(id)) onChange(value.filter((v) => v !== id));
      else onChange([...value, id]);
    };
    return /* @__PURE__ */ React.createElement("div", { className: "addon-list" }, ADDONS.map((a) => {
      const selected = a.alwaysIncluded || value.includes(a.id);
      const monthlyPrice = addonMonthlyPrice(a, scr, termYears);
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: a.id,
          className: `addon ${selected ? "selected" : ""} ${a.productImage ? "has-thumb" : ""}`,
          onClick: () => !a.alwaysIncluded && toggle(a.id),
          style: a.alwaysIncluded ? { cursor: "default", opacity: 0.95 } : {},
          role: "checkbox",
          "aria-checked": selected
        },
        /* @__PURE__ */ React.createElement("div", { className: "addon-checkbox" }),
        /* @__PURE__ */ React.createElement("div", { className: "addon-content" }, /* @__PURE__ */ React.createElement("div", { className: "addon-title" }, a.title, a.alwaysIncluded && /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 8, fontSize: 11, fontWeight: 600, color: "var(--accent)", letterSpacing: "0.06em", textTransform: "uppercase" } }, "Alltid inkludert")), /* @__PURE__ */ React.createElement("div", { className: "addon-desc" }, a.desc), a.productUrl && !a.alwaysIncluded && /* @__PURE__ */ React.createElement(
          "a",
          {
            href: a.productUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "addon-cta",
            onClick: (e) => e.stopPropagation()
          },
          "Se produkt",
          /* @__PURE__ */ React.createElement("svg", { width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement("path", { d: "M7 17 17 7" }), /* @__PURE__ */ React.createElement("path", { d: "M8 7h9v9" }))
        )),
        a.productImage && /* @__PURE__ */ React.createElement(
          "a",
          {
            href: a.productUrl || "#",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "addon-thumb",
            onClick: (e) => e.stopPropagation(),
            "aria-label": `Se ${a.title} i nettbutikken`
          },
          /* @__PURE__ */ React.createElement("img", { src: a.productImage, alt: a.title, loading: "lazy" })
        ),
        /* @__PURE__ */ React.createElement("div", { className: "addon-price" }, a.alwaysIncluded ? "Inkl." : `+${fmtKr(monthlyPrice)}`, !a.alwaysIncluded && /* @__PURE__ */ React.createElement("small", null, "per måned"))
      );
    }));
  }
  function TermStep({ term, onTermChange, termYears, onTermYearsChange }) {
    if (!SHOW_BUY) {
      return /* @__PURE__ */ React.createElement("div", { className: "binding-only" }, /* @__PURE__ */ React.createElement("div", { className: "toggle-row" }, TERM_LENGTHS.map((t) => /* @__PURE__ */ React.createElement(
        "button",
        {
          key: t.years,
          className: termYears === t.years ? "active" : "",
          onClick: () => onTermYearsChange(t.years)
        },
        t.label
      ))), /* @__PURE__ */ React.createElement("p", { className: "binding-hint" }, cfgGet("binding.hint", "Inkluderer drift, support og oppgradering. Bytt utstyr ved utløp av perioden.")));
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "term-block" }, /* @__PURE__ */ React.createElement("div", { className: `term-card ${term === "lease" ? "selected" : ""}`, onClick: () => onTermChange("lease") }, /* @__PURE__ */ React.createElement("div", { className: "term-eyebrow" }, "Mest populært"), /* @__PURE__ */ React.createElement("h3", null, "Leie / abonnement"), /* @__PURE__ */ React.createElement("p", null, "Fast månedspris med drift, support og oppgradering inkludert. Bytt utstyr ved utløp av perioden."), /* @__PURE__ */ React.createElement("div", { className: "term-price" }, /* @__PURE__ */ React.createElement("span", { className: "amount" }, "Månedspris")), /* @__PURE__ */ React.createElement("div", { className: "term-len-row", onClick: (e) => e.stopPropagation() }, TERM_LENGTHS.map((t) => /* @__PURE__ */ React.createElement("button", { key: t.years, className: termYears === t.years ? "active" : "", onClick: () => {
      onTermChange("lease");
      onTermYearsChange(t.years);
    } }, t.label)))), /* @__PURE__ */ React.createElement("div", { className: `term-card ${term === "buy" ? "selected" : ""}`, onClick: () => onTermChange("buy") }, /* @__PURE__ */ React.createElement("div", { className: "term-eyebrow" }, "Engangskjøp"), /* @__PURE__ */ React.createElement("h3", null, "Kjøp utstyret"), /* @__PURE__ */ React.createElement("p", null, "Eier utstyret selv. Inkluderer 1 års garanti og 1 års gratis support. Service-avtale tilgjengelig."), /* @__PURE__ */ React.createElement("div", { className: "term-price" }, /* @__PURE__ */ React.createElement("span", { className: "amount" }, "Engangspris")))));
  }
  function Result({ state, price, pkg, submitted, onSuccess }) {
    const room = ROOM_SIZES.find((r) => r.id === state.size);
    const platform = PLATFORMS.find((p) => p.id === state.platform);
    const ledeTpl = cfgGet("result.lede_template", "En komplett løsning for {room_label}-møterom ({people}) sertifisert for {platform_label}. Skreddersydd, men forutsigbar i pris.");
    const ledeParts = ledeTpl.replace("{room_label}", `__ROOM__${((room == null ? void 0 : room.label) || "").toLowerCase()}-møterom__/ROOM__`).replace("{people}", (room == null ? void 0 : room.people) || "").replace("{platform_label}", (platform == null ? void 0 : platform.label) || "");
    const renderLede = () => {
      const m = ledeParts.split(/__ROOM__|__\/ROOM__/);
      return [m[0], /* @__PURE__ */ React.createElement("strong", { key: "r", style: { color: "white" } }, m[1]), m[2]];
    };
    const trustItems = cfgGet("result.trust", ["1 års garanti", "Installasjon inkludert", "Levering 2 til 4 uker"]);
    const ctaPrimaryHref = cfgGet("result.cta_primary_link", "/pages/kontakt");
    const ctaSecondaryHref = cfgGet("result.cta_secondary_link", "/pages/kontakt");
    return /* @__PURE__ */ React.createElement("section", { id: "mtv-result", className: "result" }, /* @__PURE__ */ React.createElement("div", { className: "result-inner" }, /* @__PURE__ */ React.createElement("div", null, submitted && /* @__PURE__ */ React.createElement("div", { className: "result-success-banner", role: "status", "aria-live": "polite" }, /* @__PURE__ */ React.createElement("span", { className: "dot", "aria-hidden": "true" }), cfgGet("result.success_banner", "Takk, vi har mottatt forespørselen din. En rådgiver tar kontakt innen 24 timer på hverdager.")), /* @__PURE__ */ React.createElement("div", { className: "result-eyebrow" }, cfgGet("result.eyebrow", "Din anbefalte pakke")), /* @__PURE__ */ React.createElement("h2", null, pkg.name), /* @__PURE__ */ React.createElement("p", { className: "result-lede" }, renderLede()), submitted && /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 12, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("a", { className: "btn btn-primary btn-lg", href: ctaPrimaryHref }, cfgGet("result.cta_primary_label", "Snakk med en rådgiver"), " ", /* @__PURE__ */ React.createElement(Icon, { name: "arrow", size: 18 })), /* @__PURE__ */ React.createElement("a", { className: "btn btn-ghost-light btn-lg", href: ctaSecondaryHref }, /* @__PURE__ */ React.createElement(Icon, { name: "phone", size: 16 }), " ", cfgGet("result.cta_secondary_label", "Book befaring"))), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 32, display: "flex", gap: 18, flexWrap: "wrap", fontSize: 13, color: "rgba(255,255,255,0.6)" } }, trustItems.filter(Boolean).map((t, i) => /* @__PURE__ */ React.createElement("span", { key: i, style: { display: "inline-flex", alignItems: "center", gap: 6 } }, /* @__PURE__ */ React.createElement(Icon, { name: i === 0 ? "shield" : "check", size: 14 }), " ", t)))), /* @__PURE__ */ React.createElement("div", { className: "result-pkg" }, /* @__PURE__ */ React.createElement("div", { className: "result-pkg-head" }, /* @__PURE__ */ React.createElement("div", { className: "name" }, pkg.name), /* @__PURE__ */ React.createElement("div", { className: "badge" }, cfgGet("result.complete_badge", "Komplett"))), (() => {
      const screenObj = SCREEN_SIZES.find((s) => s.size === state.screen);
      const valgteTillegg = ADDONS.filter((a) => !a.alwaysIncluded && state.addons.includes(a.id)).map((a) => a.title);
      const rows = [
        { label: "Romstørrelse", value: room ? `${room.label}${room.people ? ` (${room.people})` : ""}` : "—" },
        { label: "Plattform", value: (platform == null ? void 0 : platform.label) || "—" },
        { label: "Skjerm", value: (screenObj == null ? void 0 : screenObj.label) || `${state.screen}"` },
        { label: "Tillegg", value: valgteTillegg.length ? valgteTillegg.join(", ") : "Ingen" },
        { label: "Avtaletid", value: `${state.termYears} år` }
      ];
      return /* @__PURE__ */ React.createElement("dl", { className: "result-pkg-summary" }, rows.map((r, i) => /* @__PURE__ */ React.createElement("div", { className: "row", key: i }, /* @__PURE__ */ React.createElement("dt", null, r.label), /* @__PURE__ */ React.createElement("dd", null, r.value))));
    })(), submitted ? /* @__PURE__ */ React.createElement("div", { className: "result-pkg-foot", style: !SHOW_BUY ? { gridTemplateColumns: "1fr" } : void 0 }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "lab" }, cfgGet("result.month_label", "Månedspris")), /* @__PURE__ */ React.createElement("div", { className: "price" }, fmtKr(price.month), /* @__PURE__ */ React.createElement("small", null, "/mnd"))), SHOW_BUY && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "lab" }, cfgGet("result.buy_label", "Engangskjøp")), /* @__PURE__ */ React.createElement("div", { className: "price" }, fmtKr(price.buy)))) : /* @__PURE__ */ React.createElement(InlineLeadForm, { pkg, price, state, onSuccess }))));
  }
  function InlineLeadForm({ pkg, price, state, onSuccess }) {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const room = ROOM_SIZES.find((r) => r.id === state.size);
    const platform = PLATFORMS.find((p) => p.id === state.platform);
    const screenObj = SCREEN_SIZES.find((s) => s.size === state.screen);
    const screenLabel = (screenObj == null ? void 0 : screenObj.label) || `${state.screen}"`;
    const onSubmit = async (e) => {
      e.preventDefault();
      if (submitting) return;
      setSubmitting(true);
      setError(null);
      const formEl = e.target;
      const formData = new FormData(formEl);
      const eventId = newEventId();
      const utm = getUTM();
      const fornavn = (formData.get("fornavn") || "").toString().trim();
      const etternavn = (formData.get("etternavn") || "").toString().trim();
      const navn = `${fornavn} ${etternavn}`.trim();
      const epost = (formData.get("email") || "").toString().trim();
      const telefon = (formData.get("phone") || "").toString().trim();
      const bedrift = (formData.get("bedrift") || "").toString().trim();
      const valgteTillegg = ADDONS.filter((a) => !a.alwaysIncluded && state.addons.includes(a.id)).map((a) => a.title);
      const manedsprisTall = Math.round(price.month);
      const leadPayload = {
        source: "moteromsvelger",
        client: "abc-teknikk",
        navn,
        epost,
        telefon,
        bedrift,
        stilling: "",
        melding: "",
        konfig: {
          pakkenavn: pkg.name,
          romstorrelse: (room == null ? void 0 : room.label) || "",
          plattform: (platform == null ? void 0 : platform.label) || "",
          skjerm: screenLabel,
          tillegg: valgteTillegg,
          bindingstid: `${state.termYears} år`,
          manedspris: manedsprisTall
        },
        tracking: {
          event_id: eventId,
          fbp: getCookie("_fbp"),
          fbc: getCookie("_fbc"),
          utm_source: utm.utm_source || "",
          utm_medium: utm.utm_medium || "",
          utm_campaign: utm.utm_campaign || "",
          utm_content: utm.utm_content || "",
          page_url: typeof window !== "undefined" ? window.location.href : "",
          user_agent: typeof navigator !== "undefined" ? navigator.userAgent : ""
        }
      };
      try {
        const response = await fetch(LEAD_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(leadPayload)
        });
        if (!response.ok) {
          throw new Error("Vi klarte ikke å sende forespørselen (" + response.status + "). Prøv igjen om litt.");
        }
        let data = null;
        try {
          data = await response.json();
        } catch (e2) {
          data = null;
        }
        if (!data || data.ok !== true) {
          throw new Error("Vi klarte ikke å bekrefte forespørselen. Prøv igjen, eller ring oss direkte.");
        }
        fireGenerateLead(eventId, manedsprisTall);
        if (typeof onSuccess === "function") onSuccess(eventId);
      } catch (err) {
        setError(err.message || "Kunne ikke nå serveren. Prøv igjen, eller ring oss direkte.");
        setSubmitting(false);
      }
    };
    return /* @__PURE__ */ React.createElement("form", { id: "mtv-form", className: "inline-lead-form", onSubmit, noValidate: false }, /* @__PURE__ */ React.createElement("div", { className: "inline-lead-head" }, /* @__PURE__ */ React.createElement("div", { className: "lab" }, cfgGet("form.inline_eyebrow", "Få månedsprisen")), /* @__PURE__ */ React.createElement("p", { className: "inline-lead-lede" }, cfgGet("form.inline_lede", "Legg igjen e-post og telefonnummer, så viser vi prisen og en rådgiver tar kontakt innen 24 timer."))), /* @__PURE__ */ React.createElement("div", { className: "inline-lead-grid" }, /* @__PURE__ */ React.createElement("div", { className: "form-field full" }, /* @__PURE__ */ React.createElement("label", null, "E-post"), /* @__PURE__ */ React.createElement("input", { type: "email", name: "email", required: true, placeholder: "kari@bedrift.no", autoComplete: "email" })), /* @__PURE__ */ React.createElement("div", { className: "form-field full" }, /* @__PURE__ */ React.createElement("label", null, "Telefon ", /* @__PURE__ */ React.createElement("span", { className: "hint" }, "(valgfritt)")), /* @__PURE__ */ React.createElement("input", { type: "tel", name: "phone", placeholder: "+47 ...", autoComplete: "tel" }))), error && /* @__PURE__ */ React.createElement("div", { role: "alert", className: "inline-lead-error" }, error), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "btn btn-primary btn-lg inline-lead-submit", disabled: submitting }, submitting ? "Sender …" : cfgGet("form.inline_submit", "Lås opp månedsprisen"), !submitting && /* @__PURE__ */ React.createElement(Icon, { name: "arrow", size: 16 })), /* @__PURE__ */ React.createElement("div", { className: "inline-lead-privacy" }, /* @__PURE__ */ React.createElement(Icon, { name: "shield", size: 12 }), " ", cfgGet("form.privacy", "Vi selger ikke kontaktinformasjonen din videre.")));
  }
  function StickyBar({ visible, state, term, termYears, submitted, price }) {
    const room = ROOM_SIZES.find((r) => r.id === state.size);
    const platform = PLATFORMS.find((p) => p.id === state.platform);
    const screen = state.screen;
    const termObj = TERM_LENGTHS.find((t) => t.years === termYears);
    const ctaHref = cfgGet("result.cta_primary_link", "/pages/kontakt");
    return /* @__PURE__ */ React.createElement("div", { className: `sticky-bar ${visible ? "visible" : ""}`, role: "region", "aria-label": "Konfigurasjon-sammendrag" }, /* @__PURE__ */ React.createElement("div", { className: "sticky-bar-inner" }, /* @__PURE__ */ React.createElement("div", { className: "sticky-pills" }, room && /* @__PURE__ */ React.createElement("span", { className: "sticky-pill" }, /* @__PURE__ */ React.createElement("strong", null, room.label), " · ", room.people), platform && /* @__PURE__ */ React.createElement("span", { className: "sticky-pill" }, /* @__PURE__ */ React.createElement("strong", null, platform.label)), screen && /* @__PURE__ */ React.createElement("span", { className: "sticky-pill" }, /* @__PURE__ */ React.createElement("strong", null, screen, '"'), " skjerm"), termObj && (term === "lease" || !SHOW_BUY) && /* @__PURE__ */ React.createElement("span", { className: "sticky-pill" }, "Leie · ", termObj.label), SHOW_BUY && term === "buy" && /* @__PURE__ */ React.createElement("span", { className: "sticky-pill" }, "Engangskjøp")), submitted ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "sticky-price" }, /* @__PURE__ */ React.createElement("span", { className: "amount" }, fmtKr(price.month)), /* @__PURE__ */ React.createElement("span", { className: "unit" }, cfgGet("sticky.month_unit", "per måned"))), /* @__PURE__ */ React.createElement("a", { className: "btn btn-primary", href: ctaHref }, cfgGet("sticky.cta_label_submitted", "Book befaring"), " ", /* @__PURE__ */ React.createElement(Icon, { name: "arrow", size: 16 }))) : /* @__PURE__ */ React.createElement("a", { className: "btn btn-primary", href: "#mtv-form" }, cfgGet("sticky.cta_label", "Se din pris"), " ", /* @__PURE__ */ React.createElement(Icon, { name: "arrow", size: 16 }))));
  }
  function App() {
    var _a, _b, _c, _d, _e;
    const initialRoom = (_a = ROOM_SIZES.find((r) => r.popular) || ROOM_SIZES[0]) == null ? void 0 : _a.id;
    const initialPlatform = (_b = PLATFORMS[0]) == null ? void 0 : _b.id;
    const initialScreen = (_e = (_c = ROOM_SIZES.find((r) => r.id === initialRoom)) == null ? void 0 : _c.defaultScreen) != null ? _e : (_d = SCREEN_SIZES[0]) == null ? void 0 : _d.size;
    const initialAddons = ADDONS.filter((a) => a.defaultSelected && !a.alwaysIncluded).map((a) => a.id);
    const [tier, setTier] = useState("standard");
    const [size, setSize] = useState(initialRoom);
    const [platform, setPlatform] = useState(initialPlatform);
    const [screen, setScreen] = useState(initialScreen);
    const [addons, setAddons] = useState(initialAddons);
    const [term, setTerm] = useState("lease");
    const [termYears, setTermYears] = useState(5);
    const [submitted, setSubmitted] = useState(false);
    const [submittedEventId, setSubmittedEventId] = useState(null);
    const [touched, setTouched] = useState({ size: true, platform: true, screen: true });
    const state = { tier, size, platform, screen, addons, term, termYears };
    const price = useMemo(() => calcPrice(state), [tier, size, platform, screen, addons, term, termYears]);
    const pkg = useMemo(() => suggestedPackage(state), [tier, size, platform, screen, addons]);
    useEffect(() => {
      captureUTM();
    }, []);
    useEffect(() => {
      if (tier === "standard") setPlatform("teams");
    }, [tier]);
    useEffect(() => {
      if (tier === "standard") {
        const r = STANDARD_TIER.rooms[size];
        if (r) setScreen(r.defaultScreen);
      } else {
        const room = ROOM_SIZES.find((r) => r.id === size);
        if (room) setScreen(room.defaultScreen);
      }
    }, [size, tier]);
    const [stickyVisible, setStickyVisible] = useState(false);
    useEffect(() => {
      const onScroll = () => {
        var _a2, _b2;
        const heroBottom = ((_a2 = document.querySelector(".hero")) == null ? void 0 : _a2.getBoundingClientRect().bottom) || 0;
        const heroPassed = heroBottom < 80;
        if (submitted) {
          setStickyVisible(heroPassed);
          return;
        }
        const formTop = ((_b2 = document.getElementById("mtv-form")) == null ? void 0 : _b2.getBoundingClientRect().top) || Infinity;
        setStickyVisible(heroPassed && formTop > 200);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      return () => window.removeEventListener("scroll", onScroll);
    }, [submitted]);
    const handleSubmitSuccess = (eventId) => {
      setSubmittedEventId(eventId);
      setSubmitted(true);
      setTimeout(() => {
        const el = document.getElementById("mtv-result");
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 80);
    };
    const onStart = () => {
      const top = document.getElementById("mtv-config").getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top, behavior: "smooth" });
    };
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("section", { id: "mtv-config", className: "config" }, /* @__PURE__ */ React.createElement("div", { className: "config-inner" }, /* @__PURE__ */ React.createElement("div", { style: { marginBottom: 24 } }, /* @__PURE__ */ React.createElement("div", { className: "section-eyebrow" }, cfgGet("configurator.eyebrow", "Konfigurator")), /* @__PURE__ */ React.createElement("h2", { style: { fontFamily: "var(--font-display)", fontSize: "clamp(32px, 4vw, 44px)", fontWeight: 700, letterSpacing: "-0.025em", margin: "0 0 12px", lineHeight: 1.05 } }, cfgGet("configurator.title", "Sett sammen ditt møterom")), /* @__PURE__ */ React.createElement("p", { style: { margin: 0, color: "var(--fg-2)", maxWidth: "60ch", fontSize: 17 } }, cfgGet("configurator.lede", "Fem korte steg. Vi setter sammen riktig skjerm, kamera, lyd og kontroll for plattformen din – og viser deg prisen mens du jobber."))), (() => {
      let n = 0;
      const steps = [];
      n++;
      steps.push(
        /* @__PURE__ */ React.createElement(Step, { key: "tier", num: String(n), title: cfgGet("steps.tier.title", "Velg nivå"), desc: cfgGet("steps.tier.desc", "Standard er en rimeligere, Teams-sertifisert pakke. Premium gir flere plattformer, lysere skjerm og tillegg."), active: true, done: true }, /* @__PURE__ */ React.createElement(TierStep, { value: tier, onChange: setTier }))
      );
      n++;
      steps.push(
        /* @__PURE__ */ React.createElement(Step, { key: "room", num: String(n), title: cfgGet("steps.1.title", "Romstørrelse"), desc: cfgGet("steps.1.desc", "Hvor stort er møterommet? Velg det nærmeste – vi finjusterer skjermstørrelsen i neste steg."), active: true, done: true }, /* @__PURE__ */ React.createElement(RoomSizeStep, { value: size, onChange: setSize, tier }))
      );
      if (tier !== "standard") {
        n++;
        steps.push(
          /* @__PURE__ */ React.createElement(Step, { key: "platform", num: String(n), title: cfgGet("steps.2.title", "Møteplattform"), desc: cfgGet("steps.2.desc", "NEAT-utstyret er sertifisert for alle de store plattformene. Velg den dere bruker mest."), active: true, done: true }, /* @__PURE__ */ React.createElement(PlatformStep, { value: platform, onChange: setPlatform }))
        );
      }
      n++;
      steps.push(
        /* @__PURE__ */ React.createElement(Step, { key: "screen", num: String(n), title: cfgGet("steps.3.title", "Skjermstørrelse"), desc: tier === "standard" ? "Velg skjermstørrelsen som passer rommet." : cfgGet("steps.3.desc", "Anbefalingen er basert på romstørrelsen, men du står fritt til å gå opp eller ned."), active: true, done: true }, /* @__PURE__ */ React.createElement(ScreenStep, { value: screen, onChange: setScreen, roomSize: size, tier }))
      );
      if (tier !== "standard" && ADDONS.length > 0) {
        n++;
        steps.push(
          /* @__PURE__ */ React.createElement(Step, { key: "addons", num: String(n), title: cfgGet("steps.4.title", "Tillegg"), desc: cfgGet("steps.4.desc", "De fleste klarer seg fint med standardpakken."), active: true, done: true }, /* @__PURE__ */ React.createElement(AddonsStep, { value: addons, onChange: setAddons, screen, termYears }))
        );
      }
      n++;
      steps.push(
        /* @__PURE__ */ React.createElement(Step, { key: "term", num: String(n), title: cfgGet("steps.5.title", "Avtaletid"), desc: cfgGet("steps.5.desc", "Velg lengden på avtalen. Kortere binding gir høyere månedspris, lengre binding gir lavere."), active: true, done: true }, /* @__PURE__ */ React.createElement(TermStep, { term, onTermChange: setTerm, termYears, onTermYearsChange: setTermYears }))
      );
      return steps;
    })())), /* @__PURE__ */ React.createElement(
      Result,
      {
        state,
        price,
        pkg,
        submitted,
        onSuccess: handleSubmitSuccess
      }
    ), /* @__PURE__ */ React.createElement(StickyBar, { visible: stickyVisible, state, term, termYears, submitted, price }));
  }
  const root = ReactDOM.createRoot(document.getElementById("mtv-root"));
  root.render(/* @__PURE__ */ React.createElement(App, null));
})();
